import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Phototheque from '../components/contracts/Phototheque';
import contractService from '../services/contractService';
import { ArrowLeft } from 'lucide-react';

const PhotothequePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Retrieve state passed from ContractList
  const { filters, sorting } = location.state || {};

  const fetchContracts = useCallback(async () => {
    try {
      setLoading(true);
      
      const cleanParams = {};
      
      if (filters || sorting) {
        Object.entries({
          ...filters,
          page: 1,
          limit: 10000, // Fetch all matching contracts for the phototheque
          sortBy: sorting?.sortBy || 'createdAt',
          sortOrder: sorting?.sortOrder || 'desc',
        }).forEach(([key, value]) => {
          if (value !== "" && value !== undefined && value !== null) {
            cleanParams[key] = value;
          }
        });
      } else {
        // Fallback if accessed directly
        cleanParams.limit = 10000;
        cleanParams.page = 1;
      }

      const response = await contractService.getContracts(cleanParams);

      if (response && response.data) {
        setContracts(response.data);
      }
    } catch (err) {
      console.error("Erreur lors de la récupération des contrats:", err);
      setError("Erreur lors du chargement de la photothèque.");
    } finally {
      setLoading(false);
    }
  }, [filters, sorting]);

  useEffect(() => {
    fetchContracts();
  }, [fetchContracts]);

  return (
    <div className="h-screen w-screen flex flex-col bg-gray-50 overflow-hidden">
      {/* Header bar for the Phototheque page */}
      <div className="bg-white border-b px-6 py-3 flex items-center justify-between shrink-0 shadow-sm">
        <div className="flex items-center space-x-4">
          <button 
            onClick={() => navigate('/contracts')}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 font-medium px-3 py-1.5 rounded-md hover:bg-gray-100 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Retour à la liste</span>
          </button>
          <h1 className="text-xl font-bold text-gray-800">Photothèque des contrats</h1>
        </div>
        
        {filters && (
          <div className="text-sm text-gray-500 bg-gray-100 px-3 py-1.5 rounded-md border">
            Filtres actifs: {contracts.length} résultat(s)
          </div>
        )}
      </div>

      {/* Main Content Area */}
      <div className="flex-1 p-4 overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        ) : error ? (
          <div className="flex items-center justify-center h-full text-red-600">
            <p>{error}</p>
          </div>
        ) : (
          <Phototheque contracts={contracts} />
        )}
      </div>
    </div>
  );
};

export default PhotothequePage;
